import { AccountPanelTypes } from ".";
export namespace PayRentTypes {
  export type TPayRentPageState = {
    searchResponse: AccountPanelTypes.TTenantSearchResponse[];
    billAheadResponse: any;
    next_Billing_Date?: string;
    public_key: string;
    payment_method?: any;
    card_processor?: any;
    ledger_id?: string;
    unitSearchApiResponse: any;
    tenantWebsitesConfigInfo?: any;
  };
  export type TFinancials = {
    preferred_payment_method_id: string;
    card_info: TCardInfo;
    print_setting?: any;
    is_auto_pay_enabled?: boolean;
    exempt_from_surcharge?: boolean;
    payment_grace_period?: any;
    market_type?: string;
  };
  export type TCardInfo = {
    billing_info: TBillingInfo;
    masked_card_number: string;
    expiration_date: TExpirationDate;
    token?: string;
    network_transaction_id?: string;
    last_used?: string;
  };
  export type TBillingInfo = {
    address: TAddress;
    name: string;
  };
  export type TAddress = {
    city: string;
    line1: string;
    zip_code: string;
  };
  export type TExpirationDate = {
    month: number | string;
    year: number | string;
  };
  export type TBillingDetailsInfoConfig = {
    current_balance_due?: any;
    estimated_new_charges?: any;
    next_billing_data?: string;
  };
  export type TPaymentMethodResponse = {
    data: TIndividualPaymentMethod[];
  };
  export type TIndividualPaymentMethod = {
    entity_type: string;
    id: string;
    entity_id?: string | null;
    config_type: string;
    value: TPaymentMethodValue;
  };
  export type TPaymentMethodValue = {
    modifier: string;
    description: string;
    type: string;
    status: string;
    modifier_calculation?: any;
    alternate_export_description?: null;
    payment_number_mandatory?: boolean | null;
  };
  export type TPayRentForm = {
    billingDetailsConfig?: TBillingDetailsInfoConfig;
    callBackHandler: AccountPanelTypes.TCallBackHandler;
    public_key: string;
    payment_method: TPaymentMethodResponse;
    preferred_payment_method_id?: string;
    card_info?: TCardInfo;
    name?: string;
    address: any;
    billing_info?: TBillingInfo;
    masked_card_number: any;
    cardProcessorIds: any;
    is_auto_pay_enabled?: boolean;
    isSurchargeOrDiscountAvailable?: boolean;
    tenantWebsitesConfigInfo: any;
    facilityId: string;
    tenantToken: string | undefined;
  };
  export type TCardTypeFromMethodIdFunction = (
    paymentMethodData: TPaymentMethodResponse,
    preferredPaymentId: any
  ) => string | void;
  export type TRentAssessmentDate = {
    next_rent_assessment_date: string;
  };
  export type TPaymentMethodIdFunction = (
    paymentMethodResponse: any,
    detectedCardType: string
  ) => string;
  export type TPayRentComponent = TPayRentPageState & {
    facilityId: string;
    tenantToken: string | undefined;
  };
  export type TCard_Info = {
    expiration_date?: {
      month?: string | number;
      year?: string | number;
    };
    masked_card_number?: string;
    token?: string;
  };
  export type TCard_Holder_Info = {
    name?: string;
    address?: any;
  };
  export type TCallBackHandler = (
    formRequestBody: any,
    formData?: any
  ) => Promise<any>;
  export type TExistingCardInfoConfig = {
    card_info?: TCard_Info;
    card_holder_info?: TCard_Holder_Info;
    billingDetailsConfig?: AccountPanelTypes.TBillingDetailsInfoConfig;
    preferred_payment_method_id?: string;
    cardType?: string | void;
    callBackHandler: TCallBackHandler;
    cardProcessorIds: any;
    is_auto_pay_enabled?: boolean;
    customAmount: string;
    isAutoPayOptInEnabled?: boolean;
    isAutoPayOptOutEnabled?: boolean;
    disablePayment?: boolean;
    hidePayments?: boolean;
    chargeDetails?: any;
  };
  export type TExistingCardSection = TExistingCardInfoConfig & {
    payment_method?: any;
    is_auto_pay_enabled?: boolean;
    isSurchargeOrDiscountAvailable?: boolean;
    tfwPaymentConfig?: any;
    facilityId: string;
    customAmount: string;
    setCustomAmount: (event: any) => void;
    setChargesDetails: (event: any) => void;
    customAmountError: any;
    amountResolution: string;
    setAmountResolution: (value: string) => void;
    chargesDetails?: any;
    paymentType: string;
    setPaymentType?: (value: string) => void;
    public_key: string;
    tenantToken: string | undefined;
  };
  export type TSuccessScreen = {
    tenantMail?: any;
    paidAmount?: string;
    authCode?: string;
    balanceDue?: string;
    clickHandler?: () => void;
  };
  export type TFailureScreen = {
    errorDetails?: string;
    clickHandler?: () => void;
  };
  export type TPaymentResultScreen = TSuccessScreen &
    TFailureScreen & {
      is_successful?: boolean;
      auto_pay_enabled?: boolean;
    };
}
